 
const { VITE_SCAMS_ENV, VITE_API_BASE_URL } = import.meta.env;
export const config = {
  SCAMS_ENV: VITE_SCAMS_ENV || 'dev',
  API_BASE_URL: VITE_API_BASE_URL || 'http://localhost:8080',
};
